import appConfig from '../../config/appConfig';
import {setLanguageCode} from '../../state/ducks/global';
import {selectLanguageCode} from '../../state/selectors/global';
import {dispatch, getState} from '../../state/store';
import storageService from '../storage/storageService';

const getInitialLanguageCode = () => {
    const languageCodeFromLocalStorage = storageService.getLanguageCodeFromLocalStorage();
    const languageCodeExistsInConfig = doesLanguageCodeExistInConfig(languageCodeFromLocalStorage);

    if (languageCodeExistsInConfig) return languageCodeFromLocalStorage;

    const browserLanguageCode = getBrowserLanguageCode();
    const verifiedLanguageCode = getVerifiedLanguageCode(browserLanguageCode);

    return verifiedLanguageCode;
};

const getBrowserLanguageCode = () => {
    const browserLanguageCode = window.navigator.language;

    if (browserLanguageCode) {
        return browserLanguageCode.split('_')[0].split('-')[0];
    }
};

const getVerifiedLanguageCode = (languageCode) => {
    const languageCodeExistsInConfig = doesLanguageCodeExistInConfig(languageCode);

    return languageCodeExistsInConfig ? languageCode : getDefaultLanguageCode();
};

const getLanguageByLanguageCode = (languageCode) => {
    const languages = appConfig.getLanguages();

    return languages?.find((language) => language.languageCode.toLowerCase() === languageCode?.toLowerCase());
};

const doesLanguageCodeExistInConfig = (languageCode) => !!getLanguageByLanguageCode(languageCode);

const getDefaultLanguage = () => {
    const languages = appConfig.getLanguages();
    const defaultLanguage = languages?.find((lang) => lang.default);

    return defaultLanguage;
};

const getDefaultLanguageCode = () => getDefaultLanguage()?.languageCode;

const getCurrentLanguageCode = () => selectLanguageCode(getState());

const setLanguageCodeToStores = (languageCode) => {
    storageService.setLanguageCodeToLocalStorage(languageCode);
    return dispatch(setLanguageCode(languageCode));
};

export default {
    getCurrentLanguageCode,
    getDefaultLanguage,
    getDefaultLanguageCode,
    getInitialLanguageCode,
    getLanguageByLanguageCode,
    getVerifiedLanguageCode,
    setLanguageCodeToStores,
};
